import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { CustomLayoutsService } from '../custom-layouts.service';
import { CustomLayout } from '../Models/custom-layout.model';
import { YearService } from '../../../shared-components/year/year.service';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { UserService } from '../../../shared-components/user/user.service';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { Router } from '@angular/router';
import { LayoutEditorComponent } from '../layout-editor/layout-editor.component';
import * as _ from 'lodash';

@Component({
    selector: 'app-saved-layouts-dialog',
    templateUrl: './saved-layouts-dialog.component.html',
    styleUrls: ['./saved-layouts-dialog.component.css'],
    animations: [detailExpand]
})
export class SavedLayoutsDialogComponent implements OnInit {

    layouts: CustomLayout[];
    columnsToDisplay = ['More', 'Name', 'Scope', 'OwnerName', 'LastUpOn', 'Actions'];
    dataSource = new TylerMatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    errors: ErrorList[] = [];
    userId: number;
    initialized = false;
    isAcademicHistory: boolean;

    constructor(
        private dialogRef: MatDialogRef<SavedLayoutsDialogComponent>,
        private customLayoutService: CustomLayoutsService,
        private yearService: YearService,
        private dialog: MatDialog,
        private userService: UserService,
        private router: Router
    ) { }

    ngOnInit() {
        this.isAcademicHistory = this.router.url.indexOf('academicHistory') > -1 || this.router.url.indexOf('registrationEnrollment') > -1;
        this.userId = this.userService.currentUser.Id;
        this.getLayouts();
        this.customLayoutService.observableSavedLayoutsStream$.subscribe((layouts) => {
            this.layouts = layouts;
            this.getLayouts();
        });
    }

    getLayouts() {
        if (this.customLayoutService.savedLayouts) {
            this.layouts = this.customLayoutService.savedLayouts;
            this.setLayoutSource();
        }
        if (!this.customLayoutService.savedLayouts) {
            this.customLayoutService.getLayoutsByType(this.customLayoutService.selectedLayoutType.Id, this.yearService.defaultYear.Id, this.isAcademicHistory).subscribe(results => {
                this.customLayoutService.savedLayouts = results;
                this.layouts = results;
                this.setLayoutSource();
            });
        }
    }

    setLayoutSource() {
                this.initialized = true;
                this.dataSource.data = this.layouts.filter(l => l.TylerDefault == false);
                setTimeout(() => {
                    this.dataSource.sort = this.sort;
                }, 0);
    }

    addLayoutClick() {
        let layoutsDialog = this.dialog.open(LayoutEditorComponent, { height: '80vh', minWidth: '1000px', disableClose: true });
        layoutsDialog.componentInstance.operation = 'Add';
    }

    editClick(layout: CustomLayout) {
        let layoutsDialog = this.dialog.open(LayoutEditorComponent, { height: '80vh', minWidth: '1000px', disableClose: true });
        layoutsDialog.componentInstance.operation = 'Edit';
        layoutsDialog.componentInstance.layout = layout;
    }

    duplicateClick(layout: CustomLayout) {
        let layoutsDialog = this.dialog.open(LayoutEditorComponent, { height: '80vh', minWidth: '1000px', disableClose: true });
        layoutsDialog.componentInstance.duplicate = true;
        layoutsDialog.componentInstance.operation = 'Add';
        layoutsDialog.componentInstance.layout = _.cloneDeep(layout);
        layoutsDialog.componentInstance.layout.Id = 0;
    }

    deleteClick(layout: CustomLayout) {
        const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
            disableClose: true,
        });
        deleteConfirmDialog.componentInstance.headerLabel = 'Delete Layout';
        deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete this layout?';
        deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
        deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
            if (deleteObject) {
                this.customLayoutService.deleteLayout(layout.Id).subscribe(result => {
                    if (result.toLowerCase() != 'success') {
                        this.errors.push({
                            fieldName: null,
                            fieldRef: null,
                            errorMsg: result
                        });
                    }
                    else {
                        this.customLayoutService.getLayoutsByType(this.customLayoutService.selectedLayoutType.Id, this.yearService.defaultYear.Id, true).subscribe((layouts) => {
                            this.customLayoutService.savedLayouts = layouts;
                        });
                    }
                });
            }
        });
    }

    selectLayout(layout: CustomLayout) {
        this.dialogRef.close(layout);
    }

    expandAll(expand: boolean) {
        this.dataSource.expandAll(expand);
    }

    cancelClick() {
        this.dialogRef.close();
    }

}
